var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.961,
    height: 109.305,
    viewBox: "0 0 123.961 109.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -7.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8,29.032a5.96,5.96,0,0,0,3-8l-4.9-10.3a5.978,5.978,0,0,0-7.8-2.9,68.894,68.894,0,0,0-21.6,14A52.249,52.249,0,0,0,4,44.732c-2.6,8.6-4,20.3-4,35.2v30.7a6.018,6.018,0,0,0,6,6H45.3a6.018,6.018,0,0,0,6-6v-39.3a6.017,6.017,0,0,0-6-6H26.5c.2-10.1,2.6-18.2,7-24.3C37.1,36.133,42.5,32.133,49.8,29.032Z",
    fill: "#ff909d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,29.032a5.961,5.961,0,0,0,3-8l-4.9-10.2a5.979,5.979,0,0,0-7.8-2.9,72.439,72.439,0,0,0-21.5,13.9,53.37,53.37,0,0,0-14.6,23q-3.9,12.6-3.9,35.1v30.7a6.018,6.018,0,0,0,6,6H116a6.018,6.018,0,0,0,6-6v-39.3a6.017,6.017,0,0,0-6-6H97.1c.2-10.1,2.6-18.2,7-24.3C107.7,36.133,113.1,32.133,120.4,29.032Z",
    fill: "#ff909d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.8707b0ca4c5eb66e0bef365e2f1b45b0.svg";
export { ForwardRef as ReactComponent };